<template>
    <b-modal
        id="edit-period"
        v-model="showModal"
        modal-class="apprentice-default-modal edit-period"
        ref="edit-period"
        size="md"
        :title="$t('periods.edit_period')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        @ok="storePeriod">
        <div class="edit-period">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    show
                    variant="danger">
                    {{
                        $t(
                            'periods.you_did_not_fill_in_all_mandatory_fields_correctly_please_check_the_fields_and_try_again',
                        )
                    }}
                </b-alert>
            </div>
            <b-alert
                v-else
                variant="warning"
                show>
                {{ $t('common.all_fields_are_mandatory') }}
            </b-alert>

            <b-form-group
                class="title"
                label-for="period-title-input"
                :label="$t('periods.period_title')">
                <template #label> {{ $t('common.title') }} <span class="required">*</span> </template>
                <b-form-input
                    id="period-title-input"
                    v-model="title"
                    :placeholder="$t('common.title')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="period-submission-opening"
                label-for="period-submission-opening-input"
                :label="$t('periods.registration_opens_from')">
                <b-form-datepicker
                    class="apprentice-date-picker btn-submission-opening"
                    id="period-submission-opening-input"
                    v-model="submissionOpening"
                    menu-class="datedropdown"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('periods.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('periods.no_date_selected')"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        weekday: 'short',
                    }"></b-form-datepicker>
            </b-form-group>
            <b-form-group
                class="period-submission-deadline"
                label-for="period-submission-deadline-input"
                :label="$t('periods.registration_deadline')">
                <b-form-datepicker
                    class="apprentice-date-picker btn-submission-deadline"
                    id="period-submission-deadline-input"
                    v-model="submissionDeadline"
                    menu-class="datedropdown"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('periods.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('periods.no_date_selected')"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        weekday: 'short',
                    }"></b-form-datepicker>
            </b-form-group>

            <b-form-group
                class="period-start-date"
                label-for="period-start-date-input"
                :label="$t('periods.start_date')">
                <template #label> {{ $t('periods.start_date') }} <span class="required">*</span> </template>
                <b-form-datepicker
                    class="apprentice-date-picker btn-start-date"
                    id="period-start-date-input"
                    v-model="startDate"
                    menu-class="datedropdown"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('periods.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('periods.no_date_selected')"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        weekday: 'short',
                    }"></b-form-datepicker>
            </b-form-group>

            <b-form-group
                class="period-end-date"
                label-for="period-end-date-input"
                :label="$t('periods.end_date')">
                <template #label> {{ $t('periods.end_date') }} <span class="required">*</span> </template>
                <b-form-datepicker
                    class="apprentice-date-picker btn-end-date"
                    id="period-end-date-input"
                    v-model="endDate"
                    menu-class="datedropdown"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('periods.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('periods.no_date_selected')"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        weekday: 'short',
                    }"></b-form-datepicker>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-period-edit-modal-component.vue',
    data() {
        return {
            period: null,
            submissionOpening: null,
            submissionDeadline: null,
            startDate: null,
            endDate: null,
            title: '',
            showModal: false,
            hasError: false,
        };
    },
    methods: {
        show(period) {
            this.showModal = true;
            this.period = period;
            this.title = period.title;
            this.submissionOpening = period.sign_up_from_date;
            this.submissionDeadline = period.sign_up_until_date;
            this.startDate = period.start_date;
            this.endDate = period.end_date;
            this.hasError = false;
        },

        storePeriod(bvModalEvent) {
            if (!this.areAllFieldsValidated()) {
                this.hasError = true;
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();
            let data = {
                title: this.title,
                sign_up_from_date: this.submissionOpening,
                sign_up_until_date: this.submissionDeadline,
                start_date: this.startDate,
                end_date: this.endDate,
            };

            axios
                .post(this.routes.managePeriodsUpdate(this.period.id), data)
                .then((response) => {
                    this.$emit('update-period', response.data);
                    this.alert.success();
                })
                .catch((error) => {
                    this.alert.ajaxError(error);
                });
        },

        areAllFieldsValidated() {
            this.hasError = false;

            return (
                this.title !== null &&
                this.title !== '' &&
                this.submissionDeadline !== null &&
                this.submissionDeadline !== '' &&
                this.submissionOpening !== null &&
                this.submissionOpening !== '' &&
                this.startDate !== null &&
                this.startDate !== '' &&
                this.endDate !== null &&
                this.endDate !== ''
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
